export default __webpack_public_path__ + "static/media/red-mountain-4.33ff2e67.PNG";